/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'code': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 616.192l321.344 206.624V673.664L130.016 555.52l191.328-118.144V287.2L0 494.88v121.312zM389.312 896h110.592l162.048-768H550.624L389.312 896zm313.376-608.8v150.176L893.952 555.52 702.688 673.632v149.152L1024 616.192V494.88L702.688 287.2z"/>'
  }
})
